import { Route } from '@angular/router';
import {
  accountManagerRoutes,
  OnboardingLoginRedirectComponent,
  OnboardingRedirectComponent,
  ResetRedirectComponent,
} from '@libs/account-manager';
import { AuthGuard, lazyLoadedAuthRoutes } from '@tmx/auth';

export const appRoutes: Route[] = [
  {
    path: 'onboarding',
    children: [
      {
        path: 'menu',
        component: OnboardingRedirectComponent,
      },
      {
        path: 'login',
        component: OnboardingRedirectComponent,
      },
      {
        path: 'reset',
        component: OnboardingRedirectComponent,
      },
      {
        path: '**',
        component: OnboardingRedirectComponent,
      },
    ],
  },
  {
    path: 'reset',
    component: ResetRedirectComponent,
  },
  { path: 'forgot', redirectTo: 'auth/forgot', pathMatch: 'full' },
  { path: 'login', redirectTo: 'auth/login', pathMatch: 'full' },
  { path: 'terms', redirectTo: 'ams/terms', pathMatch: 'full' },
  lazyLoadedAuthRoutes,
  {
    path: 'tid/redirect',
    component: OnboardingLoginRedirectComponent,
  },
  {
    path: 'ams',
    canActivate: [AuthGuard()],
    children: accountManagerRoutes,
  },
  {
    path: '**',
    redirectTo: 'ams',
  },
];
